import { z } from 'zod/v4';

export const extraInfoSchema = z.object({
  isBorder: z.boolean(),
  maxAddress: z.number(),
  minAddress: z.number(),
  roadClass: z.number(),
  routeNum1: z.number(),
  routeNum2: z.number(),
  routeNum3: z.number(),
  streetName: z.string(),
});

export type ExtraInfo = z.infer<typeof extraInfoSchema>;
